import React from 'react';
import { useTranslation } from 'react-i18next';
import { Layout, Text } from '@oneaudi/unified-web-components';
import { SYS_SPACE_FIXED_100 } from '@oneaudi/unified-web-common';

export interface SpecsContentProps {
  value: string;
  specId: string;
  amount?: string;
}

const SpecsContent: React.FC<SpecsContentProps> = ({ value, specId, amount }) => {
  const { t } = useTranslation();

  return (
    <Layout direction="column" rowGap={SYS_SPACE_FIXED_100}>
      <Text data-testid={`${value}-${specId}`}>
        {value}
        {specId === 'ENGINE_CYLINDERS' &&
          value !== '-' &&
          t(`featuresAndSpecsSection.categories.nonAudiOverview.specs.cylinderEngine`)}
      </Text>
      {!!amount?.length && (
        <Text data-testid={`${amount}-${specId}`}>
          {amount}
          {specId === 'TRANSMISSION' &&
            amount !== '-' &&
            t(`featuresAndSpecsSection.categories.nonAudiOverview.specs.transmissionSpeed`)}
        </Text>
      )}
    </Layout>
  );
};

export default SpecsContent;
